// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";



// 注册路由插件
Vue.use(VueRouter);

// 定义路由规则
const routes = [
  {
    path: "/", // 默认路径
    name: "Home",
    component: () => import('@/pages/Home'),
  },
  {
    path: "/consultation", 
    name: "Consultation",
    component: () => import('@/pages/Consultation'),
  },
];

// 创建路由实例
const router = new VueRouter({
  routes,
});

// 导出路由实例
export default router;
